export const MetaLocationJob = [
  {
    value: 'Hồ Chí Minh',
    id: '9bc00bbf-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hà Nội',
    id: '9bc00b64-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bắc Ninh',

    id: '9bc00904-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hải Phòng',
    id: '9bc00ba3-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hưng Yên',
    id: '9bc00bea-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Đồng Nai',
    id: '9bc00ae9-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bình Dương',
    id: '9bc0094a-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Đà Nẵng',
    id: '9bc00abc-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hải Dương',
    id: '9bc00b8e-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Tây Ninh',
    id: '9bc01d35-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bà Rịa - Vũng Tàu',
    id: '9bc00883-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Khánh Hòa',
    id: '9bc00bff-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Long An',
    id: '9bc00c83-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hà Nam',
    id: '9bc00b4e-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quảng Ninh',
    id: '9bc01ccd-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Thái Nguyên',
    id: '9bc01d5f-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bắc Giang',
    id: '9bc008d4-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Cần Thơ',
    id: '9bc00a85-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hậu Giang',
    id: '9bc01e81-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hà Tĩnh',
    id: '9bc00b7a-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Ninh Bình',
    id: '9bc00cb4-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Thanh Hóa',
    id: '9bc01d74-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Phú Thọ',
    id: '9bc00cd9-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Lâm Đồng',
    id: '9bc00c43-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Vĩnh Phúc',
    id: '9bc01e00-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Gia Lai',
    id: '9bc00b1e-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'An Giang',
    id: '9bbffd17-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quảng Ngãi',
    id: '9bc01c78-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Kiên Giang',
    id: '9bc01dd7-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Thừa Thiên Huế',
    id: '9bc01d85-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Nghệ An',
    id: '9bc00ca3-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Nam Định',
    id: '9bc00c91-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Đồng Tháp',
    id: '9bc00b05-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quảng Trị',
    id: '9bc01ce7-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Vĩnh Long',
    id: '9bc01dea-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quảng Nam',
    id: '9bc00d0c-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bình Định',
    id: '9bc00930-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Thái Bình',
    id: '9bc01d4a-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Hòa Bình',
    id: '9bc00bd5-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Đắk Lắk',
    id: '9bc00ad6-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bình Phước',
    id: '9bc00a38-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bình Thuận',
    id: '9bc00a51-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bến Tre',
    id: '9bc0091a-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Lào Cai',
    id: '9bc00c70-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quảng Bình',
    id: '9bc00cfa-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Lạng Sơn',
    id: '9bc00c5c-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Ninh Thuận',
    id: '9bc00cc7-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Tiền Giang',
    id: '9bc01d9f-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Yên Bái',
    id: '9bc01e14-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Cao Bằng',
    id: '9bc00aa1-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Phú Yên',
    id: '9bc00ceb-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Đắk Nông',
    id: '9bc01e95-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Bạc Liêu',
    id: '9bc008eb-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Quốc tế',
    id: '9bc01e53-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Sóc Trăng',
    id: '9bc01d03-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'ĐBSCL',
    id: '9bc01e66-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Điện Biên',
    id: '9bc01e41-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Trà Vinh',
    id: '9bc01db1-eddd-11ef-ada4-0242c0a8000a',
  },
  {
    value: 'Tuyên Quang',
    id: '9bc01dc6-eddd-11ef-ada4-0242c0a8000a',
  },
];
